import { AddressType, UploadedImage } from '../../common/CommonTypes';

export type AlloyWheelSpecificErrors = {
    damagedWheel?: string;
    dateOfIncident?: string;
    damageType?: string;
    damageSize?: string;
    closeUpImage?: string;
    distanceImage?: string;
};

export type AlloyPageErrors = {
    alloyType?: string;
    mileage?: string;
    permissionGranted?: string;
    alloyWheelSpecifics?: AlloyWheelSpecificErrors;
    noRepairAddressSelected?: string;
};

export type AlloyWheelRepairRequest = {
    id: number;
    productReference: string;
    name?: string;
    dateOfIncident?: string;
    damagedWheel?: string;
    damageType: string;
    damageSize: string;
    additionalInformation?: string;
    uploadedImages: UploadedImage[];
};

export type AlloyPageState = {
    alloyType: string;
    mileage?: string | number;
    alloyWheelRepairRequests: AlloyWheelRepairRequest[];
    alloyFormErrors?: AlloyPageErrors;
    repairRequestSelectedIndex: number;
    alloyStage: AlloyProcessStages;
    repairAddresses: AddressType[];
    selectedRepairAddressId: string | null;
    hasErrors: boolean;
    permissionGranted: boolean;
    selectedWheels: string[];
    currentRepairRequest?: AlloyWheelRepairRequest;
    showCancelAlert: boolean;
    updateWheel: string;
    scrollToAddress: boolean;
    isLoadingOnSubmission: boolean;
};

export type DamageSizeOption = {
    id: string;
    text: string;
    value: string;
    disabled: boolean;
};

export enum AlloyProcessStages {
    General,
    WheelSelection,
    IndividualWheel,
    Summary
}

export const ReducerActionNames = {
    SelectAlloyType: 'set-alloy-type',
    UpdateAlloyErrors: 'update-alloy-errors',
    UpdateMileage: 'update-mileage',
    UpdateWheelRepairRequest: 'update-wheel-repair-request',
    UpdateUploadedImages: 'update-uploaded-images',
    StartNewWheelRequest: 'start-new-wheel-request',
    FetchCurrentWheelRequest: 'fetch-current-wheel-request',
    UpdateAlloyStage: 'update-alloy-stage',
    AddWheelRequest: 'add-wheel-request',
    SetPolicyData: 'set-policy-data',
    AddRepairAddress: 'add-repair-address',
    UpdateRepairAddress: 'update-repair-address',
    UpdateRepairAddressSelected: 'set-repair-address-selected',
    SetHasErrors: 'set-has-errors',
    SetPermissionGranted: 'set-permission-granted',
    RemoveWheel: 'remove-selected-wheel',
    SetWheel: 'set-wheel',
    ShowCancelAlert: 'show-alert',
    UpdateWheel: 'update-wheel',
    ScrollToAddress: 'scroll-to-address',
    LoadingOnRequestSubmission: 'set-loading-request-submission'
} as const;

export const AlloyTypes = {
    StandardAlloy: 'Standard alloy',
    DiamondCut: 'Diamond cut',
    TwoTone: 'Two tone'
} as const;

export const DamageTypes = {
    Scratch: 'Scratch',
    Scuff: 'Scuff',
    Corroded: 'Corroded',
    Cracked: 'Cracked',
    Buckled: 'Buckled'
} as const;

export const WheelPositions = {
    PassengerFront: 'Passenger Front Wheel',
    DriverFront: 'Driver Front Wheel',
    PassengerRear: 'Passenger Rear Wheel',
    DriverRear: 'Driver Rear Wheel'
} as const;

export const DamageSizes = {
    OneQuarter: '1 Quarter',
    TwoQuarters: '2 Quarters',
    ThreeQuarters: '3 Quarters',
    FourQuarters: '4 Quarters'
} as const;

export const HelpText = {
    AlloyType: 'alloy_repair_request.help_text.alloy_type',
    DateOfIncident: 'alloy_repair_request.help_text.date_of_incident',
    TypeofDamage: 'alloy_repair_request.help_text.type_of_damage',
    SizeOfDamage: 'alloy_repair_request.help_text.size_of_damage',
    CloseUp: 'alloy_repair_request.help_text.close_up',
    Distance: 'alloy_repair_request.help_text.distance',
    AdditionalImages: 'alloy_repair_request.help_text.additional_images'
} as const;
